import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_PROJECT,
    StoreType,
    ProjectProps,
    ProjectUserList,
    AccountUserList,

    LoadProjectById,
    LoadProjectUsers,
    LoadAccountUsers,
    setProjectEdit,
    setProjectReloadEdit,
    setProjectUserList,
    setAccountUserList,
    initProject,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    projectId = null,
}: ProjectProps) => {
    const project = useSelector((state: StoreType) => state.project.projectEdit)
    const reloadEdit = useSelector((state: StoreType) => state.project.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setProjectReloadEdit(false))
        setTimeout(() => {
            dispatch(setProjectReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        setLoadState(PENDING)
        const promiseArray: Promise<any>[] = []

        if (projectId === 0) {
            dispatch(setProjectEdit(initProject))
        } else {
            promiseArray.push(
                LoadProjectById(projectId, userData.accountId).then((res) => {
                    dispatch(setProjectEdit(res))
                }),
            )
        }

        promiseArray.push(
            LoadProjectUsers(projectId).then((res) => {
                const newProjectUserList: ProjectUserList = { [projectId]: res }
                dispatch(setProjectUserList(newProjectUserList))
            }),
            LoadAccountUsers(userData.accountId).then((accountUsers) => {
                const newAccountUserList: AccountUserList = { [userData.accountId]: accountUsers }
                dispatch(setAccountUserList(newAccountUserList))
            }),
        )
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
            reload()
        })
    }, [])

    const addAccess = hasAccess(PRM_PROJECT, ADD)
    const editAccess = hasAccess(PRM_PROJECT, EDIT)
    const allowedToEdit = editAccess || project.owner === userData.userId

    if (projectId === 0 && !addAccess) return <AccessDenied />
    if (projectId !== 0 && !allowedToEdit) return <AccessDenied />
    if (!project) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {project.id ? `${lang.editProject} # ${project.id}` : lang.addProject}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form project={project} />
                }
                {
                    reloadEdit
                    && <Form project={project} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
